// extracted by mini-css-extract-plugin
module.exports = {"section":"NewsHeaderSection-section_1ceec1fb","title":"NewsHeaderSection-title_dc84e4f2","content":"NewsHeaderSection-content_eb36e372"};